import { useParams, Link } from "react-router-dom";
import { useFetch, label } from "../lib/api";
import { btn, Loading, Badge } from "../components/kit";

export default function PublicProfile() {
  const { id } = useParams();
  const { data: p, loading, error } = useFetch(`/users/${id}/public`);
  if (loading) return <div className="container-x py-10"><Loading text="Loading profile…" /></div>;
  if (error) {
    return (
      <div className="container-x py-16 max-w-2xl" data-testid="public-profile-unavailable">
        <h1 className="text-3xl font-bold">Profile unavailable</h1>
        <p className="mt-3 text-sub">{error}</p>
        <Link to="/" className={`${btn()} mt-6`} data-testid="public-profile-home-link">Go to homepage</Link>
      </div>
    );
  }
  const facts = [["Location", p.location], ["Availability", p.availability], ["Services", p.services], ["Experience", p.experience], ["Education", p.education]].filter(([, v]) => v);
  return (
    <div className="container-x py-10 max-w-3xl" data-testid="public-profile">
      <article>
        <p className="eyebrow mb-2">OpenPath member</p>
        <h1 className="text-3xl md:text-4xl font-extrabold">{p.name}</h1>
        {p.headline && <p className="mt-2 text-lg text-sub">{p.headline}</p>}
        {p.bio && <p className="mt-5 whitespace-pre-line">{p.bio}</p>}
        {p.skills?.length > 0 && (
          <div className="mt-5 flex flex-wrap gap-2" data-testid="public-profile-skills">
            {p.skills.map((s) => <Badge key={s} tone="blue">{s}</Badge>)}
          </div>
        )}
        {facts.length > 0 && (
          <dl className="mt-6 grid gap-4 sm:grid-cols-2 card p-5">
            {facts.map(([k, v]) => <div key={k}><dt className="text-sm font-semibold text-sub">{k}</dt><dd className="font-medium whitespace-pre-line">{v}</dd></div>)}
          </dl>
        )}
        {p.portfolio?.length > 0 && (
          <section className="mt-8" aria-labelledby="pp-portfolio">
            <h2 id="pp-portfolio" className="text-xl font-bold">Portfolio & work samples</h2>
            <ul className="mt-3 space-y-3">
              {p.portfolio.map((it) => (
                <li key={it.id} className="card p-4">
                  <Badge tone="grey">{label(it.kind)}</Badge>
                  <p className="mt-1 font-semibold">{it.url ? <a className="link" href={it.url} target="_blank" rel="noopener noreferrer">{it.title}</a> : it.title}</p>
                  {it.description && <p className="text-sm text-sub">{it.description}</p>}
                </li>
              ))}
            </ul>
          </section>
        )}
      </article>
    </div>
  );
}
